module.exports = __webpack_public_path__ + "static/media/golf-hoyo.736471f3.png";